"use client";

import * as S from "./styles.ts";
import { Button } from "@template/components";
import { useEffect, useState } from "react";
import { Switch } from "@template/components";
import getUuidFromSlug from "@/lib/api-server/admin/getUuidFromSlug";
import { toggleAdminPagePublished } from "@/lib/api-server/admin/page/toggleAdminPagePublished";
import { isDarkMode } from "@helpers/isDarkMode";
import { EditorThemeProvider } from "@template/providers/EditorThemeProvider.tsx";

const PublishToggle = ({
  value,
  onChange,
  slug,
}: {
  value: boolean;
  onChange: (val: boolean) => void;
  slug: string;
}) => {
  const [loading, setLoading] = useState(false);

  const onChangePublished = async (val: boolean) => {
    setLoading(true);
    const uuid = await getUuidFromSlug(slug);
    if (uuid) {
      const { success: isPublished } = await toggleAdminPagePublished(
        uuid,
        val
      );
      if (isPublished) {
        onChange(val);
      }
    }
    setLoading(false);
  };

  return (
    <S.SwitchWrapper>
      <Switch
        color="secondary"
        label="Published"
        variant="flat"
        checked={value}
        onChange={onChangePublished}
        disabled={loading}
      />
    </S.SwitchWrapper>
  );
};

const AdminTopBar = ({ type }: { type?: "published" | "unpublished" }) => {
  const [published, setPublished] = useState(type === "published");
  const [slug, setSlug] = useState<string | null>(null);
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    if (typeof slug === "string") return;
    // remove leading and end slash, if any, keeping any slashes in between
    const path = window.location.pathname.replace(/^\/|\/$/g, "");
    setSlug(path);
    setDarkMode(isDarkMode);
  }, [slug]);

  if (!type) return;

  return (
    <EditorThemeProvider>
      <S.TopBarWrapper>
        <S.TopBarContainer>
          <PublishToggle
            value={published}
            onChange={setPublished}
            slug={slug}
          />
          <Button
            variant="solid"
            size="sm"
            color="secondary"
            navigation={{ href: `/admin?slug=${slug}` }}
          >
            Edit Page
          </Button>
        </S.TopBarContainer>
      </S.TopBarWrapper>
    </EditorThemeProvider>
  );
};

export default AdminTopBar;
